import {
  PortableText as BasePortableText,
  PortableTextProps,
} from '@portabletext/react'
import components from './components'

function PortableText(props: PortableTextProps) {
  return (
    <BasePortableText
      components={components}
      onMissingComponent={false}
      {...props}
    />
  )
}

export default PortableText
